import { auth } from "../firebase";

const API_BASE_URL =
  process.env.REACT_APP_ACCOUNTING_API_BASE_URL || "http://localhost:4001/api/v1";

async function getBearerToken() {
  const user = auth.currentUser;
  if (!user) throw new Error("You must be signed in.");
  try {
    return await user.getIdToken(false); // use cached token
  } catch {
    return await user.getIdToken(true);  // force refresh only on failure
  }
}

async function request(path, { method = "GET", body } = {}) {
    const token = await getBearerToken();
  const headers = { "Content-Type": "application/json" };
  if (token) headers.Authorization = 'Bearer ' + token;
  const response = await fetch(`${API_BASE_URL}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload?.error || `Request failed with status ${response.status}`);
  }
  return payload;
}

const base = (tenantId, clientId) =>
  `/tenant/${encodeURIComponent(tenantId)}/client-profiles/${encodeURIComponent(clientId)}/related-parties`;

export async function listRelatedParties(tenantId, clientId) {
  const data = await request(base(tenantId, clientId));
  return { relatedParties: Array.isArray(data?.relatedParties) ? data.relatedParties : [] };
}

export async function buildRelatedPartyGraph(tenantId, clientId) {
  return request(`${base(tenantId, clientId)}/build`, { method: "POST" });
}

export async function addManualRelatedParty(tenantId, clientId, payload) {
  return request(base(tenantId, clientId), { method: "POST", body: payload });
}

export async function updateRelatedParty(tenantId, clientId, relId, payload) {
  return request(
    `${base(tenantId, clientId)}/${encodeURIComponent(relId)}`,
    { method: "PATCH", body: payload }
  );
}

export async function deleteRelatedParty(tenantId, clientId, relId) {
  return request(
    `${base(tenantId, clientId)}/${encodeURIComponent(relId)}`,
    { method: "DELETE" }
  );
}

export async function listRelatedPartySuggestions(tenantId, clientId) {
  return request(`${base(tenantId, clientId)}/suggestions`);
}

export async function updateRelatedPartySuggestion(tenantId, clientId, sugId, fields) {
  return request(
    `${base(tenantId, clientId)}/suggestions/${encodeURIComponent(sugId)}`,
    { method: "PATCH", body: fields }
  );
}

export async function mergeRelatedParties(tenantId, clientId, sourceId, mergeIntoId) {
  return request(
    `${base(tenantId, clientId)}/${encodeURIComponent(sourceId)}/merge`,
    { method: "PATCH", body: { mergeIntoId } }
  );
}




